import React from 'react'
import { Button, ButtonProps } from 'primereact/button'
import classnames from 'classnames'
import mscc from './InsightsButton.module.scss'

export interface InsightsButtonProps extends ButtonProps {
  secondary?: boolean
  rounded?: boolean
  small?: boolean
  large?: boolean
}

export const InsightsButton: React.FC<InsightsButtonProps> = ({
  rounded = false,
  secondary,
  className,
  small,
  large,
  ...buttonProps
}) => (
  <Button
    className={classnames(mscc.button, className, {
      ['p-button-rounded']: rounded,
      ['p-button-secondary']: secondary
    })}
    {...(small ? { size: 'small' } : {})}
    {...(large ? { size: 'large' } : {})}
    {...buttonProps}
  />
)
